export default function Section ({ children, h }) {
    return <section className="container">
        { h && <h2>{h}</h2> }
        { children }
    </section>
}